export function formatCurrency(value: number | null) {
  if (value == null) {
    return "N/A";
  }

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: value >= 1000 ? 0 : 2
  }).format(value);
}

export function formatNumber(value: number | null) {
  if (value == null) {
    return "N/A";
  }

  return new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 2
  }).format(value);
}

export function formatPercent(value: number | null) {
  if (value == null) {
    return "N/A";
  }

  return `${value > 0 ? "+" : ""}${value.toFixed(1)}%`;
}

export function formatDate(value: string | null | undefined) {
  if (value == null || value.trim() === "") return "N/A";
  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric"
  }).format(new Date(`${value}T00:00:00`));
}

export function formatShortDate(value: string | null | undefined) {
  if (value == null || value.trim() === "") return "N/A";
  // Always include year: multi-year Form 4 history makes month/day-only labels
  // ambiguous when sorting Filed/Traded (e.g. "Jun 5" from 2025 vs 2026).
  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    year: "2-digit"
  }).format(new Date(`${value}T00:00:00`));
}

export function formatExchangeLabel(exchange: string) {
  const labels: Record<string, string> = {
    MISSING_EXCHANGE: "Missing exchange",
    UNKNOWN: "Unknown exchange"
  };

  return labels[exchange] ?? exchange;
}

/** Format trade value / market cap in basis points for trader materiality. */
export function formatMaterialityBps(value: number | null | undefined) {
  if (value == null || !Number.isFinite(value)) return "N/A";
  if (Math.abs(value) >= 100) return `${Math.round(value)} bps`;
  if (Math.abs(value) >= 10) return `${value.toFixed(1)} bps`;
  return `${value.toFixed(2)} bps`;
}


/** "informative_buy" -> "Informative Buy" for enum-ish canonical values. */
export function titleCase(value: string): string {
  return value
    .split("_")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}
